import { memo, useCallback } from "react"

import { IconCrossMedium } from "@izettle/otto"
import { Button, IconButton } from "@izettle/react"

import { useDropdown } from "../../hooks"

import { Footer, Header, List, StyledModal } from "./components"

export const Modal = memo(() => {
  const { children, close, done, isMultiple, isOpen, reset, texts } = useDropdown()

  const cancel = useCallback(() => {
    reset()
    close()
  }, [close, reset])

  const submit = useCallback(() => {
    done()
    close()
  }, [close, done])

  return (
    <StyledModal isOpen={isOpen} onRequestClose={close}>
      <Header>
        <IconButton
          variant="minor"
          svgIcon={IconCrossMedium}
          title={texts.cancel}
          onClick={cancel}
        />
      </Header>

      <List>{children}</List>

      {isMultiple && (
        <Footer>
          <Button variant="inline" onClick={cancel}>
            {texts.cancel}
          </Button>
          <Button onClick={submit}>{texts.done}</Button>
        </Footer>
      )}
    </StyledModal>
  )
})
